import React from 'react';
import clsx from 'clsx';
import { Modal as AntModal, ModalProps } from 'antd';
import { X as CloseIcon } from 'react-feather';
import './PanelModal.scss';

interface Props extends Omit<ModalProps, 'title' | 'footer'> {
  title?: React.ReactNode;
  header?: React.ReactNode;
  footer?: React.ReactNode;
  children: React.ReactNode;
}

const BASE_CLASS = 'ui-kit-panel-modal';

export default function PanelModal({
  title,
  header,
  footer,
  children,
  className,
  closable = true,
  width = 1100,
  ...rest
}: Props) {
  return React.cloneElement(
    <AntModal centered className={clsx(BASE_CLASS, className)} />,
    {
      width,
      footer: null,
      closable,
      maskClosable: closable,
      keyboard: closable,
      closeIcon: <CloseIcon />,
      ...rest,
    },
    <>
      {(title || header) && (
        <div className={`${BASE_CLASS}-header`}>
          {title && <h2 className={`${BASE_CLASS}-header__title`}>{title}</h2>}
          {header}
        </div>
      )}
      <div className={`${BASE_CLASS}-body`}>{children}</div>
      {footer && <div className={`${BASE_CLASS}-footer`}>{footer}</div>}
    </>,
  );
}
